module.exports = __webpack_public_path__ + "media/images/icons/delete-c2035faaabbaae482454421fc0e1958c.png";